import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import BeamXRAuthProvider from "./auth/BeamXRAuthProvider";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// App is mounted once. It previously appeared twice, once inside StrictMode and once outside,
// which ran the whole app, and its authentication callback handling, in duplicate.
root.render(
  <BeamXRAuthProvider>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </BeamXRAuthProvider>
);
